import { render, staticRenderFns } from "./cardSmsProduct.vue?vue&type=template&id=65f0fb5c&scoped=true&"
import script from "./cardSmsProduct.vue?vue&type=script&lang=js&"
export * from "./cardSmsProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0fb5c",
  null
  
)

export default component.exports